document.addEventListener('DOMContentLoaded', function () {
  class CartUpsellSlider extends HTMLElement {
    constructor() {
      super();
      this.sliderRef = this.querySelector('[data-slider]');
      this.paginationRef = this.querySelector('[data-pagination]') || null;
      this.initSlider = this.initSlider.bind(this);
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.swiper = new Swiper(this.sliderRef, {
        loop: false,
        spaceBetween: 8,
        autoplay: false,
        slidesPerView: 1.1,
        freeMode: true,
        pagination: {
          el: this.paginationRef,
          clickable: true,
        },
        mousewheel: {
          forceToAxis: true,
        },
      });
    }

    disconnectedCallback() {
      this.swiper.destroy();
    }
  }
  customElements.define('cart-upsell-slider', CartUpsellSlider);
});
